import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class VssLoadingService {

  loadingSubject = new BehaviorSubject(false);

  constructor() { }

  // showLoading() {
  //   this.loadingSubject.next(true);
  // }

  // hideLoading() {
  //   this.loadingSubject.next(false);
  // }

  private loadingCount = 0;
  private loadingStartTime = 0;
  private minLoadingTime = 400; // ms

  showLoading() {
    this.loadingCount++
    if (this.loadingCount === 1) {
      this.loadingStartTime = Date.now()
      this.loadingSubject.next(true)
    }
  }

  hideLoading() {
    this.loadingCount = Math.max(0, this.loadingCount - 1)
    if (this.loadingCount === 0) {
      const elapsed = Date.now() - this.loadingStartTime // tgian đã load
      // Nếu đã đủ thời gian tối thiểu thì tắt ngay, nếu chưa thì delay cho đủ
      if (elapsed >= this.minLoadingTime) {
        this.loadingSubject.next(false)
      } else {
        setTimeout(() => {
          // Nếu trong lúc chờ không có tác vụ mới thì tắt loading
          if (this.loadingCount === 0) {
            this.loadingSubject.next(false)
          }
        }, this.minLoadingTime - elapsed)
      }
    }
  }
}
